import React from 'react';
import PropTypes from 'prop-types';
import {
  reduxForm, getFormValues, change, getFormSyncErrors, reset,
} from 'redux-form';
import { connect } from 'react-redux';
import { t } from 'i18next';
import Modal from 'react-modal';
import { Beforeunload } from 'react-beforeunload';
import Step1 from './steps/Step1';
import Step3 from './steps/Step3/';
import Step4 from './steps/Step4';
import Step5 from './steps/Step5';
import Step6 from './steps/Step6';
import FormProgressBar from '../ReactComponent/FormProgressBar';
import SignupBanner from '../ReactComponent/SignupBanner';
import {
  measurementValidate, isUSZip, isCANPostal, listCompleted,
} from '../../utils/validator';
import apiGetCanadaPostAddress from '../CreateQuoteForm/api';
import {
  putReduxServiceLevelQuotes,
  putReduxServiceLevelCode,
} from '../CreateQuoteForm/actions';
import {
  cancelOrder,
} from './api';
import { getContactInfo } from '../../services/contacts';
import {
  Title,
  SubTitle,
  SingleButtonContainer,
  ButtonGroup,
  FormContainer,
  Step6TopContainer,
  StepTopLeftContainer,
  Step5TopContainer,
  Step5Title,
  Step5SubTitle,
} from './css';
import formApiToData from '../../utils/apiMapping';
import {
  apiGetOrderById, apiDuplicateByBillNumber, apiCreateOrder, apiUpdateOrder, apiGetRates,
} from '../../services/orders';
import {
  scrollToTop,
  isCanadianAddress,
  formatDate,
  getTimeObject,
  checkBillToAccountProtectedStatus,
  getCountry,
  isAmericanAddress,
  getCountryFromZip,
  serviceLevelCodeSelection,
} from '../../utils/func';
import {
  DeliveryTypes,
  Divisions,
  PaymentMethods,
  PaymentMethodsShipment,
  SamedayServiceType,
  PrefillNumberTypes,
  QuoteStatuses,
  BillToMethods,
  shipmentPickupServiceTypes,
  IsYesOrNo,
  CommerceServiceType,
  SamedayShipmentType,
  UnitType,
  PrintingLabels,
} from '../../utils/enums';
import { endpoints, routes } from '../../utils/constants';
import QuestionsBlock from '../ReactComponent/QuestionsBlock';
import ModalBoxStyle from '../_styledComponents/ModalBoxStyle';
import { list as unitsList } from '../ReactComponent/Measurement/Units/utils';
import { getPreferences } from '../../services/users';
import PrimaryButton from '../../lib/ui/buttons/PrimaryButton';
import SecondaryButton from '../../lib/ui/buttons/SecondaryButton';
import Step2 from './steps/Step2/index';
import mock from './mock.json';
import utils from '../../utils/utils';
import { apiDownloadBol, apiDownloadPdfLabel } from '../../services/documents';
import CreateShipmentModals from './Modals/CreateShipmentModals';
import RevertAlertModal from './Modals/RevertAlertModal';
import { initAccessorialsForm } from '../../lib/ui/accessorialsPicker/methods';
import ModifyOrderModal from './Modals/ModifyOrderModal';
import { addressValidation } from '../../utils/addressValidation';
import LastActionsTopBottomNav from './steps/ContentBox/LastActionsTopBottomNav';
import apiDBErrorMessage from '../../utils/apiDBErrorMessage';
import handleDeliveryType from '../../utils/deliveryAddress';
// import { ModalBodyAlert } from '../CreateQuoteForm/css';

const formName = 'CreateShipmentForm';
let serviceLevels = '';

const initialValues = {
  division: Divisions.Freight.name,
  deliveryType: { name: DeliveryTypes.Commercial, desc: 'CommercialServiceDesc' },
  measurementType: unitsList[0],
  accessorials: {},
  dangerDisable: false,
  measurementList: [{}],
  commodityType: '',
  selectedUnits: '',
  paymentMethod: PaymentMethodsShipment.Other,
  numberTypeSelected: {
    name: 'None',
    value: 'none',
  },
  droppingFreightOff: { name: IsYesOrNo.No, value: false },
  regularScheduledPickup: { name: IsYesOrNo.No, value: false },
  accessByTrailer: { name: IsYesOrNo.Yes, value: true },
  createBillOfLading: true,
  broker: {
    name: '',
    emailAddress: '',
    phoneNumber: '',
  },
  shipmentType: SamedayShipmentType.Regular,
  isShipperAddressCanadaPost: false,
  isConsigneeAddressCanadaPost: false,
};

class CreateShipmentForm extends React.Component {
  constructor(props) {
    super(props);
    const { fields } = utils.isDisconnected ? mock : props;

    this.steps = [
      fields.data.datasource.step1Title.value || 'step1Title',
      fields.data.datasource.step2Title.value || 'step2Title',
      fields.data.datasource.step3Title.value || 'step3Title',
      fields.data.datasource.step4Title.value || 'step4Title',
      fields.data.datasource.step5Title.value || 'step5Title',
      fields.data.datasource.step6Title.value || 'step6Title',
    ];
    this.state = {
      currentStep: 0,
      data: {},
      accList: [],
      accessorialsBase: [],
      modalIsOpen: false,
      errorMessage: null,
      quoteNumberError: null,
      preExistingValuesExist: false,
      isReturningShipment: false,
      aCharges: undefined,
      incompleteAddresses: {
        shipper: false, consignee: false, shipperPostalId: null, consigneePostalId: null,
      },
      userHasBeenWarned: false,
      isManageContactPermission: false,
      cancelShipment: false,
      cancelShipmentWarning: false,
      cancelShipmentSuccess: false,
      embargoErrorMessage: false,
      getRatesError: false,
      modalCreateFromQuote: false,
      modalModifyOrder: false,
      touchedField: null,
      hideLossChanges: false,
      overrideShipper: null,
      overrideConsignee: null,
      createShipmentFlag: false,
    };
    this.addressFieldsRef = React.createRef();
  }

  componentDidMount() {
    const {
      division, isAuthenticated, dispatch, userId, userEmail, fields,
    } = this.props;

    dispatch(change(formName, 'selectedUnits', t(UnitType.Imperial)));
    dispatch(change(formName, 'billToDayAndRoss', true));

    if (isAuthenticated) {
      dispatch(change(formName, 'division', division));
      dispatch(change(formName, 'quoteDest', userEmail));
    } else {
      dispatch(change(formName, 'paymentMethod', PaymentMethods.CreditCard));
    }

    const accessorials = utils.isDisconnected ? mock.fields.data.accessorialsItem : fields.data.accessorialsItem;
    initAccessorialsForm(accessorials, formName, dispatch);

    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      const currentDate = new Date();
      const readyDate = new Date();
      const closingDate = new Date();

      const readyDateMinutes = this.getClosestMinutes(currentDate.getMinutes());
      const readyDateHours = currentDate.getMinutes() > 45 ? currentDate.getHours() + 1 : currentDate.getHours();

      readyDate.setHours(readyDateHours, readyDateMinutes);
      closingDate.setHours(17, 0, 0, 0); // 5:00 PM...
      this.updatePickupDate(readyDate, closingDate);
      if (isAuthenticated === false) {
        this.updatePickupDate(new Date('1970-01-01T00:00:00'), closingDate);
      } else {
        const dontUsePref = !!((urlParams.get('quoteNumber')
          || urlParams.get('shipmentId')
          || urlParams.get('probillNumber')
          || urlParams.get('shipmentNumber')));

        getPreferences(userId, division)
          .then((res) => {
            if (res.status === 200 && res.data) {
              this.updatePickupDate(new Date(res.data.readyTime),
                res.data.closingTime !== '0001-01-01T00:00:00'
                  || res.data.closingTime !== '1970-01-01T00:00:00' ? new Date(res.data.closingTime) : closingDate);

              const formedData = this.formPrefData(res.data);
              // Don't apply user preferences state when loading from an existing quote/shipment
              if (!dontUsePref) {
                this.setState({
                  ...formedData,
                });

                if (formedData.overrideContactId && formedData.overrideContactId !== 0) {
                  getContactInfo(formedData.overrideContactId).then((res) => {
                    this.setState({
                      overrideShipper: res.data,
                    });
                  });
                }

                if (formedData.overrideConsigneeAddress && formedData.overrideConsigneeAddress !== 0) {
                  getContactInfo(formedData.overrideConsigneeAddress).then((res) => {
                    this.setState({
                      overrideConsignee: res.data,
                    });
                  });
                }
              }
            }
          });
      }

      const divisionQueryParam = urlParams.get('division');
      if (divisionQueryParam) {
        dispatch(change(formName, 'division', divisionQueryParam));
      }

      const serviceTypeQueryParam = urlParams.get('serviceType');
      dispatch(change(formName, 'serviceType', serviceTypeQueryParam
        || shipmentPickupServiceTypes[division || divisionQueryParam || Divisions.Freight.name][0]));

      // Handle with queryString requests. eg. recreate, based on an existing quote, etc
      this.handleQueryStringRequests();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.formData && this.props.formData) {
      let hasChanges = false;

      if ((prevProps.formData.shipperAddress !== this.props.formData.shipperAddress)
                || (prevProps.formData.consigneeAddress !== this.props.formData.consigneeAddress)) {
        hasChanges = true;
      }

      if ((prevProps.formData.shipperPostalZipCode !== this.props.formData.shipperPostalZipCode)
                || (prevProps.formData.consigneePostalZipCode !== this.props.formData.consigneePostalZipCode)) {
        hasChanges = true;
      }

      if (hasChanges) {
        this.addressAsyncValidator();

        const { dispatch, putReduxServiceLevelCode } = this.props;

        // Clear duplicated/original service level so it does not get reused after address changes
        dispatch(change(formName, 'serviceLevelCode', ''));
        putReduxServiceLevelCode('');
      }

      serviceLevels = serviceLevelCodeSelection(this.props.formData);
    }
  }

  getClosestMinutes = (minutes) => {
    const intervals = [15, 30, 45, 60];
    let closest = intervals.reduce((previous, current) => (Math.abs(current - minutes) < Math.abs(previous - minutes) ? current : previous));
    if (minutes > closest) closest = intervals[intervals.indexOf(closest) + 1];
    if (closest === 60) return 0;
    return closest;
  };

  updatePickupDate = (readyDate, closingDate) => {
    const { dispatch } = this.props;
    const currentDate = new Date();
    const readyDateFormatted = getTimeObject(readyDate);
    const closingDateFormatted = getTimeObject(closingDate);

    dispatch(change(formName, 'pickupDate', formatDate(currentDate)));
    dispatch(change(formName, 'readyTime.hours', readyDateFormatted.hours));
    dispatch(change(formName, 'readyTime.minutes', readyDateFormatted.minutes));
    dispatch(change(formName, 'readyTime.amOrPm', (readyDateFormatted.hours === '00' && readyDateFormatted.minutes === '00')
      ? '' : readyDateFormatted.amOrPm));
    dispatch(change(formName, 'closingTime.hours', closingDateFormatted.hours % 12 || 12));
    dispatch(change(formName, 'closingTime.minutes', closingDateFormatted.minutes));
    dispatch(change(formName, 'closingTime.amOrPm', closingDateFormatted.amOrPm));
  };

  formPrefData = (resData) => {
    const { dispatch } = this.props;
    const urlParams = new URLSearchParams(window.location.search);
    const dontUsePref = !!((urlParams.get('quoteNumber') || urlParams.get('shipmentId') || urlParams.get('probillNumber')));

    const brokerObj = {
      name: resData.brokerName,
      emailAddress: resData.brokerEmail,
      phoneNumber: resData.brokerTelephone,
    };

    const droppingFreight = IsYesOrNo.No;
    const regularPickup = (resData.isPickupScheduled) ? resData.isPickupScheduled : IsYesOrNo.No;

    const droppingFreightObj = {
      name: droppingFreight,
      value: droppingFreight === IsYesOrNo.Yes,
    };
    const pickupObj = {
      name: regularPickup,
      value: regularPickup === IsYesOrNo.Yes,
    };

    const billToAccount = resData.billToAccountNumber?.accountNumber || resData.billToAccountNumber;

    return {
      ...resData,
      fromContactId: dontUsePref ? undefined : resData.fromContactId,
      toContactId: dontUsePref ? undefined : resData.toContactId,
      deliveryType: dontUsePref ? undefined : this.getDeliveryType(resData.serviceType),
      billTo: dontUsePref ? undefined : dispatch(change(formName, 'billTo', billToAccount)),
      broker: dontUsePref ? undefined : dispatch(change(formName, 'broker', brokerObj)),
      droppingFreightOff: dontUsePref ? undefined : dispatch(change(formName, 'droppingFreightOff', droppingFreightObj)),
      regularScheduledPickup: dontUsePref ? undefined : dispatch(change(formName, 'regularScheduledPickup', pickupObj)),
      // Map termsAndConditions from user preferences to pre-check the checkbox
      termsAccepted: dontUsePref ? undefined : dispatch(change(formName, 'termsAccepted', resData.termsAndConditions === true)),
    };
  };

  handleQueryStringRequests = () => {
    const { dispatch } = this.props;
    const urlParams = new URLSearchParams(window.location.search);

    // Get data from a provided quoteNumber
    if (urlParams.get('quoteNumber')) {
      const quoteNumber = urlParams.get('quoteNumber');
      dispatch(change(formName, 'numberTypeSelected', { name: 'Use Quote Number', value: PrefillNumberTypes.quote, type: 'quote' }));
      dispatch(change(formName, 'quoteOrShipmentNumber', quoteNumber));
      this.populateFormBasedOnAnExistingQuoteOrShipment('fromQuote', quoteNumber, this.getServiceLevelCode);
    }

    // Recreate an order
    if (urlParams.get('recreate') === 'true' && urlParams.get('probillNumber')) {
      // const probillNumber = urlParams.get('probillNumber');
      const shipmentNumber = urlParams.get('shipmentNumber');

      dispatch(change(formName, 'numberTypeSelected', { name: 'Use Shipment Number', value: PrefillNumberTypes.shipment, type: 'recreate' }));
      dispatch(change(formName, 'quoteOrShipmentNumber', shipmentNumber));
      this.populateFormBasedOnAnExistingQuoteOrShipment('recreateOrder', shipmentNumber);
    }

    // Open order draft
    if (urlParams.get('shipmentId')) {
      const shipmentId = urlParams.get('shipmentId');
      dispatch(change(formName, 'numberTypeSelected', { name: 'Use Shipment Number', value: PrefillNumberTypes.shipment, type: 'order' }));
      dispatch(change(formName, 'quoteOrShipmentNumber', shipmentId));
      this.populateFormBasedOnAnExistingQuoteOrShipment('fromDraft', shipmentId);
    }
  };

  nextStep = async (e) => {
    if (e) {
      e.preventDefault();
    }

    const {
      formData: { measurementList, shipperAddress, consigneeAddress },
      formData,
      putReduxServiceLevelQuotes,
      putReduxServiceLevelCode,
      dispatch,
      isAuthenticated,
      valid,
      division,
      userId,
      userEmail,
      userName,
      serviceLevelCode,
      billingAccounts,
    } = this.props;

    const { currentStep } = this.state;

    const hasMeasureMents = this.state.currentStep !== 1 || measurementList;
    if (valid && hasMeasureMents) {
      if (currentStep === 0) {
        if (!formData.consigneeCountry) {
          dispatch(change(formName, 'consigneeCountry', getCountryFromZip(formData.consigneePostalZipCode)));
        }

        if (!((isAmericanAddress(shipperAddress) && isCanadianAddress(consigneeAddress))
          || (isCanadianAddress(shipperAddress) && isAmericanAddress(consigneeAddress)))) {
          dispatch(change(formName, 'broker', {
            name: '',
            emailAddress: '',
            phoneNumber: '',
          }));
        }

        if ((t('EmbargoFlag') === 'ON') && ((formData.shipperAddress && formData.shipperAddress.includes('BC'))
          || (formData.consigneeAddress && formData.consigneeAddress.includes('BC')))) {
          const errorMessage = t('EmbargoErrorMessage');
          this.setState({ modalIsOpen: true, errorMessage, embargoErrorMessage: true });
        } else if ((t('EmbargoUSFlag') === 'ON') && (formData && formData.division === Divisions.Freight.name)) {
          const shipperCountry = getCountry(formData.shipperAddress);
          const consigneeCountry = getCountry(formData.consigneeAddress);
          if (shipperCountry === 'US' || consigneeCountry === 'US') {
            const errorMessage = t('EmbargoUSWarning');
            this.setState({ modalIsOpen: true, errorMessage, embargoErrorMessage: true });
          }
        }

        this.setState((prevState) => ({ currentStep: prevState.currentStep + 1 }), () => {
          setTimeout(() => scrollToTop(), 200);
        });

        if (isAuthenticated) {
          checkBillToAccountProtectedStatus(dispatch, division, userId, billingAccounts);
        }

        const USShipment = (isCANPostal(formData.shipperPostalZipCode) && isUSZip(formData.consigneePostalZipCode))
          || (isUSZip(formData.shipperPostalZipCode) && isCANPostal(formData.consigneePostalZipCode));
        dispatch(change(formName, 'USShipment', USShipment));
      }

      if (currentStep === 1) {
        if (!listCompleted(measurementList)) {
          return;
        }

        this.setState((prevState) => ({ currentStep: prevState.currentStep + 1 }), () => {
          scrollToTop();
          setTimeout(() => scrollToTop(), 200);
        });
      }

      if (currentStep === 2) {
        this.setState((prevState) => ({ currentStep: prevState.currentStep + 1 }), () => {
          scrollToTop();
          setTimeout(() => scrollToTop(), 200);
        });
      } else if (currentStep === 3) {
        formData.copyOrderID = this.state.hasOrderIdQuote;

        // Check if this shipment is being created from a quote
        // If the quote/shipment number contains "Q", don't make GetRate call (use quote rates)
        const { quoteOrShipmentNumber } = formData;
        const isFromQuote = quoteOrShipmentNumber && quoteOrShipmentNumber.toString().toUpperCase().includes('Q');

        // Only call apiGetRates if NOT creating from a quote
        if (!isFromQuote) {
          // DEMO: The following code is using the new api call, which not working. For the demo, this code can be commented.
          // if (!(this.props.serviceLevelQuotes && this.props.serviceLevelQuotes.length > 0)) {
          apiGetRates({
            putReduxServiceLevelQuotes,
            putReduxServiceLevelCode,
            serviceLevelCode,
            formData,
            userId,
            userEmail,
            userName,
            prevStep: this.prevStep,
            isAuthenticated,
            isShipmentForm: true,
          }).catch((error) => {
            const errorMessage = error?.errors?.message ? apiDBErrorMessage(error.errors.message) : null;
            this.setState({ modalIsOpen: true, errorMessage: errorMessage || t('ErrorMessage'), getRatesError: true });
          });
        }

        this.setState((prevState) => ({ currentStep: prevState.currentStep + 1 }), () => {
          scrollToTop();
        });
      }
    }
  };

  updateState = (name, value, callback) => this.setState({ [name]: value }, callback);

  prevStep = (e) => {
    if (e) {
      e.preventDefault();
    }

    this.setState((prevState) => ({ currentStep: prevState.currentStep - 1 }));
    scrollToTop();
  };

  editStepOne = (e) => {
    e.preventDefault();
    this.setState({ currentStep: 0 });
  };

  editStepTwo = (e) => {
    e.preventDefault();
    this.setState({ currentStep: 1 });
  };

  editStepThree = (e) => {
    e.preventDefault();
    this.setState({ currentStep: 2 });
  };

  editStepFour = (e) => {
    e.preventDefault();
    this.setState({ currentStep: 3 });
  };

  handleCreateShipment = async () => {
    const {
      serviceLevelCode,
      formData,
      userId,
      userEmail,
      userName,
      isAuthenticated,
    } = this.props;
    const { aCharges } = this.state;

    const {
      overrideShipper,
      overrideConsignee,
    } = this.state;

    formData.overrideShipper = overrideShipper;
    formData.overrideConsignee = overrideConsignee;

    formData.copyOrderID = this.state.hasOrderIdQuote;
    this.setState({ modalIsOpen: false, errorMessage: null });

    await apiCreateOrder({
      serviceLevelCode,
      formData,
      userId,
      userEmail,
      userName,
      isAuthenticated,
      updateState: this.updateState,
      prevStep: this.prevStep,
      paymentCallback: this.gotoPaymentGateway,
      isShipmentForm: true,
      aCharges,
    }).catch((error) => {
      const errorMessage = error?.errors?.message ? apiDBErrorMessage(error.errors.message) : null;
      this.setState({
        modalIsOpen: true, errorMessage: errorMessage || t('ErrorMessage'), getRatesError: true, createShipmentFlag: true,
      });
    });

    this.setState((prevState) => ({ currentStep: prevState.currentStep + 1 }), () => {
      scrollToTop();
    });
  };

  gotoPaymentGateway = () => {
    const { isAuthenticated, formData } = this.props;
    const { paymentMethod } = formData;
    const { data } = this.state;
    const { currencyCode } = data;

    let { paymentUrl } = endpoints.shipping;
    if (currencyCode === 'US') {
      paymentUrl = endpoints.shipping.paymentUrlForUS;
    }

    if (!isAuthenticated && paymentMethod === PaymentMethods.CreditCard) {
      const openPayment = () => {
        window.open(paymentUrl);
      };

      window.setTimeout(openPayment, 5000);
    }
  };

  handleUpdateShipment = async () => {
    const {
      serviceLevelCode,
      formData,
      userId,
      userEmail,
      userName,
      isAuthenticated,
    } = this.props;

    await apiUpdateOrder({
      serviceLevelCode,
      formData,
      userId,
      userEmail,
      userName,
      isAuthenticated,
      updateState: this.updateState,
      paymentCallback: this.gotoPaymentGateway,
    }).catch((error) => {
      const errorMessage = error?.errors?.message ? apiDBErrorMessage(error.errors.message) : null;
      this.setState({ modalIsOpen: true, errorMessage: errorMessage || t('ErrorMessage'), getRatesError: true });
    });

    this.setState((prevState) => ({ currentStep: prevState.currentStep + 1 }), () => {
      scrollToTop();
    });
  };

  handleSubmit = async () => {
    let shouldUpdateShipment = false;

    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      shouldUpdateShipment = !!(urlParams.get('recreate') === 'true' && urlParams.get('update') === 'true' && urlParams.get('probillNumber'));
    }

    // DEMO: The following code is using the new api call, which not working. For the demo, this code can be commented.
    if (shouldUpdateShipment) {
      await this.handleUpdateShipment();
    } else {
      await this.handleCreateShipment();
    }
  };

  openBOL = () => {
    const { data: { shipmentNumber } } = this.state;

    if (shipmentNumber) {
      apiDownloadBol(shipmentNumber);
    }
  };

  openLabelSM = () => {
    const { data: { shipmentNumber } } = this.state;

    if (shipmentNumber) {
      apiDownloadPdfLabel(shipmentNumber, PrintingLabels.SM);
    }
  };

  openLabelLG = () => {
    const { data: { shipmentNumber } } = this.state;

    if (shipmentNumber) {
      apiDownloadPdfLabel(shipmentNumber, PrintingLabels.LG);
    }
  };

  openInNewTab = (url) => {
    const win = window.open(url, '_blank');
    win.focus();
  };

  handlePreviousQuotesLink = (event) => {
    const { formData } = this.props;

    event.preventDefault();
    const quoteOrShipmentType = formData && formData.numberTypeSelected && formData.numberTypeSelected.value;

    if (quoteOrShipmentType === PrefillNumberTypes.quote) {
      this.openInNewTab('/manage-quotes');
    }

    if (quoteOrShipmentType === PrefillNumberTypes.shipment) {
      this.openInNewTab('/manage-orders');
    }
  };

  setThirdPartyMethod = (billTo, thidpartyDetails) => {
    const { dispatch } = this.props;
    let thirdyPartyBillto;

    const hasThirdPartyDetailsKeys = Object.keys(thidpartyDetails).some((k) => thidpartyDetails[k]);

    if (hasThirdPartyDetailsKeys) {
      thirdyPartyBillto = BillToMethods.enterBillTo;
      dispatch(change(formName, 'thirdPartyAccountNumber', billTo));
      dispatch(change(formName, 'billTo', ''));
    } else {
      thirdyPartyBillto = BillToMethods.pickBillTo;
      dispatch(change(formName, 'billTo', billTo));
    }

    dispatch(change(formName, 'billToMethod', thirdyPartyBillto));
  };

  getDeliveryType = (serviceType) => {
    const { dispatch } = this.props;
    let newDeliveryType;

    if (serviceType === SamedayServiceType.Commercial) {
      newDeliveryType = {
        name: DeliveryTypes.Commercial,
        desc:
          'CommercialServiceDesc',
      };
    }

    if (serviceType === SamedayServiceType.Residential || serviceType === CommerceServiceType.Residential) {
      newDeliveryType = {
        name: DeliveryTypes.Residential,
        desc:
          'ResidentialServiceDesc',
      };
    }

    dispatch(change(formName, 'deliveryType', newDeliveryType));
  };

  dispatchFormValues = (data, callback) => {
    const { dispatch, userEmail } = this.props;
    const {
      serviceType, billTo, paymentMethod, billingAddress, billingAddressAdditional, billingCompanyName,
      billingContactName, billingEmail, billingPhoneNumber, billingPhoneNumberExt,
    } = data;
    const objBilling = {
      billingAddress,
      billingAddressAdditional,
      billingCompanyName,
      billingContactName,
      billingEmail,
      billingPhoneNumber,
      billingPhoneNumberExt,
    };

    dispatch(change(formName, 'shipperNickname', ''));
    dispatch(change(formName, 'consigneeNickname', ''));

    Object.keys(data).map((field) => {
      if (field !== 'paymentMethod' && field !== 'serviceType') {
        dispatch(change(formName, field, data[field]));
      }

      return undefined;
    });

    dispatch(change(formName, 'quoteDest', userEmail));

    if (serviceType) {
      this.getDeliveryType(serviceType);
    }

    if (paymentMethod) {
      dispatch(change(formName, 'paymentMethod', paymentMethod));
    }

    if (paymentMethod === PaymentMethods.ThirdParty && objBilling) {
      this.setThirdPartyMethod(billTo, objBilling);
    }

    if (callback) {
      callback();
    }
  };

  openModal = () => {
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    const { dispatch } = this.props;
    this.setState({
      modalIsOpen: false,
      cancelShipment: false,
      cancelShipmentWarning: false,
      cancelShipmentSuccess: false,
      embargoErrorMessage: false,
      modalCreateFromQuote: false,
      modalModifyOrder: false,
      touchedField: null,
      hideLossChanges: false,
      errorMessage: null,
    });
    dispatch(change(formName, 'rerouteToPickupModal', false));
  };

  showExpiredModal = () => {
    this.setState({ errorMessage: t('ExpiredError'), hideLossChanges: true });
    this.openModal();
  };

  cancelShipment = () => {
    const errorMessage = t('CancelShipmentMessage');

    this.setState({
      modalIsOpen: true, errorMessage, cancelShipment: true, cancelShipmentWarning: false,
    });
  };

  cancelShipmentRequest = () => {
    const { formData } = this.props;
    const { data } = this.state;

    cancelOrder(formData.shipperPostalZipCode, data.orderNumber).then((res) => {
      this.setState({ errorMessage: res.message, cancelShipmentWarning: res.hasReturnedError, cancelShipmentSuccess: !res.hasReturnedError });
    });
  };

  handleCreateByNumberError = (type) => {
    const { dispatch } = this.props;
    switch (type) {
      case QuoteStatuses.UnderReview:
        this.setState({ errorMessage: t('QuoteUnderReview') });
        break;
      case QuoteStatuses.USQuote:
        this.setState({ errorMessage: t('UsQuoteNumberError') });
        break;
      case endpoints.shipping.quotes:
        this.setState({ errorMessage: t('InvalidShipmentNumber') });
        break;
      case endpoints.shipping.shipments:
        this.setState({ errorMessage: t('InvalidShipmentNumber') });
        break;
      default:
        break;
    }

    this.setState({ modalIsOpen: true });
    dispatch(change(formName, 'quoteOrShipmentNumber', ''));
  };

  fillFormWithExistingData = (data, type, incompleteAddresses, callback) => {
    const { fields, formData } = this.props;
    const { accessorials } = formData;
    const commodities = utils.isDisconnected ? mock.fields.data.commoditiesItem : fields.data.commoditiesItem;

    data.accList = accessorials;

    // Join commodities in an only one level
    const commoditiesList = [];
    commodities.children.forEach((child) => {
      child.children.forEach((item) => {
        commoditiesList.push({
          code: item.code.value.toUpperCase(),
          name: item.description.value.toLowerCase(),
          isDangerous: item.dangerous.value,
        });
      });
    });

    if (data.items) {
      const updatedItems = [];
      data.items.forEach((item) => {
        const obj = commoditiesList.filter((commodity) => commodity.code === item.commodityType)[0];
        if (obj) {
          item.commodityType = { code: obj.code, name: obj.name };
        }

        item.pallets = item.pallets === 0 ? '' : item.pallets;
        item.pieces = item.pieces === 0 ? '' : item.pieces;

        updatedItems.push(item);
      });

      data.items = updatedItems;
    }

    if (type === 'returning' && data.shipmentType !== 'Exchange') {
      const consignee = data.to;
      const shipper = data.from;
      data.from = consignee;
      data.to = shipper;
      data.sendEmailToConsignee = false;
    }

    const updatedFormData = formApiToData(data);

    let updatingOrder = false;
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      updatingOrder = !!(urlParams.get('recreate') === 'true' && urlParams.get('update') === 'true' && urlParams.get('probillNumber'));
    }

    if (!updatingOrder) updatedFormData.specialInstructions = '';

    if (updatingOrder && data.pickupDetails) {
      const readyDate = data.pickupDetails.readyTime.split(' ');
      const readyTime = readyDate[1].split(':');
      const closingDate = data.pickupDetails.closingTime.split(' ');
      const closingTime = closingDate[1].split(':');
      [updatedFormData.pickupDate] = data.pickupDetails.readyTime.split(' ');
      updatedFormData.readyTime = {
        hours: readyTime[0],
        minutes: readyTime[1],
        amOrPm: readyDate[2],
      };
      updatedFormData.closingTime = {
        hours: closingTime[0],
        minutes: closingTime[1],
        amOrPm: closingDate[2],
      };
    }

    this.setState({
      data: updatedFormData,
      errorMessage: null,
      preExistingValuesExist: true,
      isReturningShipment: (type === 'returning'),
      incompleteAddresses,
    }, () => { this.dispatchFormValues(updatedFormData, callback); });
  };

  getServiceLevelCode = () => {
    const { formData, putReduxServiceLevelCode } = this.props;
    if (this.props.serviceLevelQuotes && this.props.serviceLevelQuotes.length) {
      const otherServiceLevelCode = { data: { serviceLevels: [] } };
      otherServiceLevelCode.data.serviceLevels = this.props.serviceLevelQuotes;
      putReduxServiceLevelCode(handleDeliveryType(formData.deliveryType, otherServiceLevelCode));
    }
  };

  populateFormBasedOnAnExistingQuoteOrShipment = async (type, code, callback) => {
    const { preExistingValuesExist, incompleteAddresses } = this.state;
    const { formData, putReduxServiceLevelQuotes, isAuthenticated } = this.props;
    const codeByQueryString = code;
    const codeByForm = formData && formData.quoteOrShipmentNumber;
    const quoteOrShipmentNumber = (code) ? codeByQueryString : codeByForm;

    this.setState({ hasOrderIdQuote: null });

    if (!quoteOrShipmentNumber) {
      if (preExistingValuesExist && type === 'fromForm') {
        this.props.dispatch(reset(formName));
        this.setState({ aCharges: undefined });
      }

      return null;
    }

    if (preExistingValuesExist && type !== 'fromForm') {
      return null;
    }

    try {
      const { dispatch } = this.props;
      let response = null;
      if (type === 'fromDraft') {
        response = (quoteOrShipmentNumber) ? await apiGetOrderById(quoteOrShipmentNumber) : null;
        this.setState({ aCharges: undefined });
      } else {
        response = (quoteOrShipmentNumber) ? await apiDuplicateByBillNumber(quoteOrShipmentNumber) : null;

        if (isAuthenticated === false
          && response && response.data
          && (response.data.accountNumber !== '0000358377' && response.data.accountNumber !== '0000201497')
        ) {
          const { dispatch } = this.props;

          // ✅ Clear form data
          dispatch(reset(formName));
          this.handleCreateByNumberError(endpoints.shipping.quotes);
          return null; // stop further execution (prevents auto-population)
        }

        // Get the order ID of a duplicated Quote:
        if (response && response.data) {
          dispatch(change(formName, 'selectedUnits', response.data.measurementType === 1 ? t(UnitType.Imperial) : t(UnitType.Metric)));
          dispatch(change(formName, 'measurementType', unitsList[1 - response.data.measurementType]));
        }

        this.setState({
          hasOrderIdQuote: response && response.data.orderType === 'Q' ? response.data.orderId : null,
          isShipment: !!(response && response.data.orderType === 'T'),
        });
      }

      if (response.data.expired === true) {
        return this.showExpiredModal();
      }

      if (response && response.data) {
        const { data } = response;

        if (data.shipmentItems && !data.items) {
          data.items = data.shipmentItems;
        }

        if (type === 'returning') {
          data.shipmentType = formData.shipmentType;
        }

        const updateIncompleteAddresses = { ...incompleteAddresses };

        if (!data.from.address1 || data.from.address1 === 'null') {
          updateIncompleteAddresses.shipper = true;
          updateIncompleteAddresses.shipperPostalId = await this.getAddressFromCanadaPost(data.from.postalCode);
        }

        if (!data.to.address1 || data.to.address1 === 'null') {
          updateIncompleteAddresses.consignee = true;
          updateIncompleteAddresses.consigneePostalId = await this.getAddressFromCanadaPost(data.to.postalCode);
        }

        if (data && data.rates && data.rates.serviceLevels && data.rates.serviceLevels.length) {
          putReduxServiceLevelQuotes(data.rates.serviceLevels);
        }

        this.setState({ aCharges: data.aCharges || null });

        // Fetch user preferences for broker details and pickup times (priority: userPreferences > duplicateByBillNumber > empty)
        const { userId, division } = this.props;
        if (isAuthenticated && userId) {
          try {
            const preferencesResponse = await getPreferences(userId, division);
            if (preferencesResponse.status === 200 && preferencesResponse.data) {
              const {
                brokerName, brokerEmail, brokerTelephone, readyTime, closingTime,
              } = preferencesResponse.data;

              // Use user preferences if available, otherwise fallback to duplicateByBillNumber data
              data.brokerName = brokerName || data.brokerName || null;
              data.brokerEmail = brokerEmail || data.brokerEmail || null;
              data.brokerPhoneNumber = brokerTelephone || data.brokerPhoneNumber || null;

              // Update pickup times from user preferences if available
              const isValidPrefReadyTime = readyTime && readyTime !== '0001-01-01T00:00:00' && readyTime !== '1970-01-01T00:00:00';
              const isValidPrefClosingTime = closingTime && closingTime !== '0001-01-01T00:00:00' && closingTime !== '1970-01-01T00:00:00';

              if (isValidPrefReadyTime && isValidPrefClosingTime) {
                // Use user preferences pickup times
                this.updatePickupDate(new Date(readyTime), new Date(closingTime));
              } else if (data.pickupDetails && data.pickupDetails.readyTime && data.pickupDetails.closingTime) {
                // Fallback to duplicateByBillNumber pickup times
                this.updatePickupDate(new Date(data.pickupDetails.readyTime), new Date(data.pickupDetails.closingTime));
              }
            }
          } catch (prefError) {
            // If fetching preferences fails, use duplicateByBillNumber pickup times if available
            if (data.pickupDetails && data.pickupDetails.readyTime && data.pickupDetails.closingTime) {
              this.updatePickupDate(new Date(data.pickupDetails.readyTime), new Date(data.pickupDetails.closingTime));
            }
          }
        }

        this.fillFormWithExistingData(data, type, updateIncompleteAddresses, callback);
        // ---------test---------
      }
    } catch (error) {
      this.handleCreateByNumberError(endpoints.shipping.quotes);
    }

    return undefined;
  };

  getAddressFromCanadaPost = async (postalCode) => {
    const result = await apiGetCanadaPostAddress(postalCode, 'PostalCodes');

    if (result && result.data && result.data.Items && result.data.Items.length > 0) {
      const resultId = result.data.Items[0].Id;
      return resultId;
    }

    return null;
  };

  handleFormChange = (e) => {
    const { formData } = this.props;
    const target = e.target.name;
    const quoteOrShipment = formData && formData.numberTypeSelected && formData.numberTypeSelected.value;
    const nonAddressWatchedFields = ['editMeasurement', 'deleteMeasurement', 'accessorials'];
    if (nonAddressWatchedFields.includes(String(target).split('.')[0]) && quoteOrShipment === PrefillNumberTypes.quote) {
      e.preventDefault();
      const { preExistingValuesExist, userHasBeenWarned } = this.state;
      const hasBeenWarned = userHasBeenWarned === true;

      if (preExistingValuesExist && !hasBeenWarned) {
        this.setState({ modalIsOpen: true });
      }
    }
  };

  handleFormClick = (e) => {
    const target = e.target.alt || e.target.innerHTML;
    const changeWatchedFieldsList = ['add more part file', 'Add another item'];
    const { formData } = this.props;
    const quoteOrShipment = formData && formData.numberTypeSelected && formData.numberTypeSelected.value;
    if (changeWatchedFieldsList.includes(String(target)) && quoteOrShipment === PrefillNumberTypes.quote) {
      e.preventDefault();
      const { preExistingValuesExist, userHasBeenWarned } = this.state;
      const hasBeenWarned = (userHasBeenWarned === true);

      if (preExistingValuesExist) {
        if (!hasBeenWarned) {
          this.setState({ modalIsOpen: true });
        }
      }
    }
  };

  handleModalButtons = (event, elName) => {
    const { dispatch } = this.props;
    const { data } = this.state;
    event.preventDefault();

    const evName = event.target.name;
    const name = (elName) || evName;

    if (name === 'createNewQuote') {
      this.setState({ userHasBeenWarned: true });
      window.open(`${routes.createQuote}?quoteNumber=${data.shipmentNumber}`);
    } else if (name === 'routeToPickup') {
      window.location.href = routes.createPickup;
    } else if (name === 'acceptErrorMessage') {
      dispatch(change(formName, 'numberTypeSelected', {
        name: 'None', value: PrefillNumberTypes.none,
      }));
    } else if (name === 'returnToStepTwo') {
      setTimeout(() => scrollToTop(), 200);
    }

    this.closeModal();
  };

  openContactPermissionModal = () => {
    const { fields } = utils.isDisconnected ? mock : this.props;

    const errorMessage = t(fields.data.datasource.ManageContactPermissionWarning.value);
    this.setState({
      modalIsOpen: true, errorMessage, currentStep: 0, isManageContactPermission: true,
    });
  };

  avoidChangesOnPrePopulatedData = (fieldName) => {
    const { formData } = this.props;
    const { numberTypeSelected, quoteOrShipmentNumber } = formData;
    const { preExistingValuesExist } = this.state;
    const isBasedOnAnExistingQuoteOrOrder = (quoteOrShipmentNumber && preExistingValuesExist
      && (numberTypeSelected && numberTypeSelected.type !== 'recreate'));

    if (isBasedOnAnExistingQuoteOrOrder) {
      this.setState({ modalCreateFromQuote: true, touchedField: fieldName }, this.openModal);
    }
  };

  createNewQuote = () => {
    const { formData } = this.props;
    window.location.href = `${routes.createQuote}?quoteNumber=${formData.quoteOrShipmentNumber}`;
  };

  handleModifyOrder = () => {
    const { data } = this.state;
    const { orderId, shipmentNumber } = data;
    window.location(`${routes.createShipment}?recreate=true&update=true&probillNumber=${orderId}&shipmentNumber=${shipmentNumber}`);
    this.closeModal();
  };

  addressAsyncValidator = () => {
    const { asyncValidate } = this.props;
    return asyncValidate();
  };

  render() {
    const {
      formData,
      valid,
      formSyncErrors,
      handleSubmit,
      submitSucceeded,
      dispatch,
      serviceLevelQuotes,
      putReduxServiceLevelCode,
      serviceLevelCode,
      isAuthenticated,
      accountNumbers,
      billingAccounts,
    } = this.props;
    const {
      currentStep,
      accessorialsBase,
      accList,
      modalIsOpen,
      errorMessage,
      quoteNumberError,
      preExistingValuesExist,
      isReturningShipment,
      incompleteAddresses,
      userHasBeenWarned,
      data,
      fromContactId,
      toContactId,
      isManageContactPermission,
      cancelShipment,
      cancelShipmentWarning,
      cancelShipmentSuccess,
      getRatesError,
      embargoErrorMessage,
      modalCreateFromQuote,
      modalModifyOrder,
      touchedField,
      hideLossChanges,
      isShipment,
    } = this.state;

    const fields = utils.isDisconnected ? mock.fields.data.datasource : this.props.fields.data.datasource;
    const commodities = utils.isDisconnected ? mock.fields.data.commoditiesItem : this.props.fields.data.commoditiesItem;
    const commodityList = { children: [...commodities.children] };
    if (formData && ((isCANPostal(formData.shipperPostalZipCode) && isUSZip(formData.consigneePostalZipCode))
      || (isUSZip(formData.shipperPostalZipCode) && isCANPostal(formData.consigneePostalZipCode)))) {
      commodityList.children = [...commodityList.children].filter((c) => c.enableForUsShipment.value === '1');
    }

    const accessorials = utils.isDisconnected ? mock.fields.data.accessorialsItem : this.props.fields.data.accessorialsItem;

    const quoteOrShipmentType = formData && formData.numberTypeSelected && formData.numberTypeSelected.value;
    const validNumberTypeSelected = quoteOrShipmentType || false;
    const isRecreate = (formData && formData.numberTypeSelected && formData.numberTypeSelected.type === 'recreate');
    const fieldsShouldBeBlocked = (formData && !isShipment && typeof (formData.quoteOrShipmentNumber) !== 'undefined'
      && !isReturningShipment && !isRecreate);

    return (
      <div>
        <Beforeunload onBeforeunload={() => "You'll lose your data!"} />
        <FormProgressBar current={currentStep} steps={this.steps} />
        <Modal
          isOpen={modalIsOpen || (formData && formData.rerouteToPickupModal)}
          onRequestClose={this.closeModal}
          style={ModalBoxStyle}
          contentLabel="Modal"
        >
          {(modalCreateFromQuote)
            ? (
              <RevertAlertModal
                primaryAction={this.closeModal}
                secondaryAction={this.createNewQuote}
                fieldLabel={touchedField}
              />
            )
            : (modalModifyOrder)
              ? (
                <ModifyOrderModal
                  primaryAction={this.closeModal}
                  secondaryAction={this.handleModifyOrder}
                />
              )
              : (
                <CreateShipmentModals
                  handleModalButtons={this.handleModalButtons}
                  closeModal={this.closeModal}
                  cancelShipmentRequest={this.cancelShipmentRequest}
                  errorMessage={errorMessage}
                  embargoErrorMessage={embargoErrorMessage}
                  getRatesError={getRatesError}
                  isManageContactPermission={isManageContactPermission}
                  cancelShipment={cancelShipment}
                  cancelShipmentWarning={cancelShipmentWarning}
                  cancelShipmentSuccess={cancelShipmentSuccess}
                  isAuthenticated={isAuthenticated}
                  fields={fields}
                  hideLossChanges={hideLossChanges}
                  createShipmentFlag={this.state.createShipmentFlag}
                />
              )}
        </Modal>

        <SignupBanner loggedIn={isAuthenticated} />

        <FormContainer>
          {submitSucceeded && (cancelShipment || (!modalIsOpen && !errorMessage)) && currentStep === 5
            ? (
              <>
                <Step6TopContainer>
                  <StepTopLeftContainer>
                    <Title>{t('ShipmentPlaced')}</Title>
                    <SubTitle>
                      {t('Shipments')}
                      :
                      {' '}
                      <b>{data.shipmentNumber}</b>
                    </SubTitle>
                  </StepTopLeftContainer>
                  <LastActionsTopBottomNav
                    probillNumber={data.probillNumber ? data.probillNumber : data.orderNumber}
                    isUSShipper={formData?.USShipment}
                    openBOL={this.openBOL}
                    openLabelSM={this.openLabelSM}
                    openLabelLG={this.openLabelLG}
                    cancelShipment={this.cancelShipment}
                    isAuthenticated={isAuthenticated}
                    shipmentNumber={data.shipmentNumber}
                  />
                </Step6TopContainer>
                {formData.paymentMethod === 'CreditCard' && !isAuthenticated
                    && (
                    <SubTitle>
                      <b>{t('Alert')}</b>
                      {' : '}
                      {t('UnauthenticatedDisclaimer')}
                    </SubTitle>
                    )}
                <Step6
                  formData={formData}
                  quoteData={data}
                  serviceLevelQuotes={serviceLevelQuotes}
                  chosenServiceLevelCode={serviceLevelCode}
                  parentFields={fields}
                  billingAccounts={billingAccounts}
                  prevStep={this.prevStep}
                  isUSShipper={formData?.USShipment}
                  openBOL={this.openBOL}
                  openLabelSM={this.openLabelSM}
                  openLabelLG={this.openLabelLG}
                  cancelShipment={this.cancelShipment}
                  currencyCode={data && data.currencyCode}
                  serviceLevels={serviceLevels}
                />
                <LastActionsTopBottomNav
                  probillNumber={data.probillNumber ? data.probillNumber : data.orderNumber}
                  isUSShipper={formData?.USShipment}
                  openBOL={this.openBOL}
                  openLabelSM={this.openLabelSM}
                  openLabelLG={this.openLabelLG}
                  cancelShipment={this.cancelShipment}
                  isAuthenticated={isAuthenticated}
                />
              </>
            ) : (
              // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events
              <form
                onSubmit={handleSubmit(this.handleSubmit)}
                onChange={(e) => preExistingValuesExist && !userHasBeenWarned && this.handleFormChange(e)}
                onClick={(e) => preExistingValuesExist && !userHasBeenWarned && this.handleFormClick(e)}
              >
                {currentStep === 4 && valid && (
                  <Step5TopContainer>
                    <StepTopLeftContainer>
                      <Step5Title>{t('Service')}</Step5Title>
                      <Step5SubTitle>{t('Step5SubTitle')}</Step5SubTitle>
                    </StepTopLeftContainer>
                    <PrimaryButton
                      type="submit"
                      label={(!isAuthenticated && formData.paymentMethod === PaymentMethods.CreditCard) ? t('FinalizeAndPay') : t('SubmitShipment')}
                    />
                  </Step5TopContainer>
                )}
                <Step1
                  step={currentStep}
                  formData={formData}
                  getServiceLevel={this.getServiceLevel}
                  dispatch={dispatch}
                  loggedIn={isAuthenticated}
                  accountNumbers={accountNumbers}
                  handlePreviousQuotesLink={this.handlePreviousQuotesLink}
                  handleExistingQuoteOrShipment={
                    this.populateFormBasedOnAnExistingQuoteOrShipment
                  }
                  handleBillTo={data.billTo}
                  quoteNumberError={quoteNumberError}
                  quoteOrShipmentType={quoteOrShipmentType}
                  validNumberTypeSelected={validNumberTypeSelected}
                  preExistingValuesExist={preExistingValuesExist}
                  incompleteAddresses={incompleteAddresses}
                  parentFields={fields}
                  billingAccounts={billingAccounts}
                  fromContactId={fromContactId}
                  toContactId={toContactId}
                  isLoggedIn={isAuthenticated}
                  addressFieldsRef={this.addressFieldsRef}
                  openContactPermissionModal={this.openContactPermissionModal}
                  fieldsShouldBeBlocked={fieldsShouldBeBlocked}
                  avoidChanges={this.avoidChangesOnPrePopulatedData}
                />
                <Step2
                  fields={fields}
                  formData={formData}
                  step={currentStep}
                  valid={valid}
                  formName={formName}
                  dispatch={dispatch}
                  accessorialsList={accList}
                  preExistingValuesExist={preExistingValuesExist}
                  parentFields={fields}
                  error={formSyncErrors}
                  loggedIn={isAuthenticated}
                  commoditiesList={commodityList}
                  fieldsShouldBeBlocked={fieldsShouldBeBlocked}
                  avoidChanges={this.avoidChangesOnPrePopulatedData}
                  validate={this.dispatchFormValues}
                  isReturningShipment={isReturningShipment}
                  unitsList={unitsList}
                />
                <Step3
                  accessorialsList={accessorials}
                  formData={formData}
                  formName={formName}
                  step={currentStep}
                  dispatch={dispatch}
                  prevStep={this.prevStep}
                  nextStep={this.nextStep}
                  preExistingValuesExist={preExistingValuesExist}
                  parentFields={fields}
                  loggedIn={isAuthenticated}
                  valid={valid}
                  fieldsShouldBeBlocked={fieldsShouldBeBlocked}
                  avoidChanges={this.avoidChangesOnPrePopulatedData}
                />
                <Step4
                  step={currentStep}
                  formData={formData}
                  dispatch={dispatch}
                  formName={formName}
                  parentFields={fields}
                  formSyncErrors={formSyncErrors}
                />
                <Step5
                  formData={formData}
                  dispatch={dispatch}
                  step={currentStep}
                  accessorialsBase={accessorialsBase}
                  editStepOne={this.editStepOne}
                  editStepTwo={this.editStepTwo}
                  editStepThree={this.editStepThree}
                  editStepFour={this.editStepFour}
                  serviceLevelQuotes={serviceLevelQuotes}
                  putReduxServiceLevelCode={putReduxServiceLevelCode}
                  serviceLevelCode={serviceLevelCode}
                  parentFields={fields}
                  billingAccounts={billingAccounts}
                  serviceLevels={serviceLevels}
                />
                {(currentStep === 4 && valid) ? (
                  <ButtonGroup>
                    <SecondaryButton
                      label={t('Back')}
                      onClick={this.prevStep}
                      showArrow
                      isIconLeftPosition
                    />
                    <PrimaryButton
                      type="submit"
                      label={(!isAuthenticated && formData.paymentMethod === PaymentMethods.CreditCard) ? t('FinalizeAndPay') : t('SubmitShipment')}
                    />
                  </ButtonGroup>
                ) : (currentStep === 0) ? (
                  <SingleButtonContainer>
                    <PrimaryButton
                      label={t('Next')}
                      onClick={this.nextStep}
                      disabled={!(valid && !(currentStep === 1 && !listCompleted(formData.measurementList)))}
                    />
                  </SingleButtonContainer>
                ) : (
                  <ButtonGroup>
                    <SecondaryButton
                      label={t('Back')}
                      onClick={this.prevStep}
                      showArrow
                      isIconLeftPosition
                    />
                    <PrimaryButton
                      label={t('Next')}
                      onClick={this.nextStep}
                      disabled={!valid || (currentStep === 3 && !formData.termsAccepted)}
                    />
                  </ButtonGroup>
                )}
              </form>
            )}
          <QuestionsBlock />
        </FormContainer>
      </div>
    );
  }
}

CreateShipmentForm = reduxForm({
  form: formName,
  initialValues,
  validate: measurementValidate,
  asyncValidate: addressValidation,
  asyncBlurFields: ['consigneeAddress', 'shipperAddress', 'consigneeAddressLine1', 'shipperAddressLine1', 'consigneeNickname', 'shipperNickname'],
  asyncChangeFields: ['shipperPostalZipCode', 'consigneePostalZipCode'],
})(CreateShipmentForm);

CreateShipmentForm.propTypes = {
  fields: PropTypes.object,
  formData: PropTypes.object,
  valid: PropTypes.bool,
  formSyncErrors: PropTypes.object,
  handleSubmit: PropTypes.func,
  submitSucceeded: PropTypes.bool,
  dispatch: PropTypes.func,
  serviceLevelQuotes: PropTypes.array,
  putReduxServiceLevelCode: PropTypes.func,
  serviceLevelCode: PropTypes.string,
  isAuthenticated: PropTypes.bool,
  accountNumbers: PropTypes.array,
  billingAccounts: PropTypes.array,
  division: PropTypes.string,
  userId: PropTypes.string,
  userEmail: PropTypes.string,
  asyncValidate: PropTypes.func,
  putReduxServiceLevelQuotes: PropTypes.func,
  userName: PropTypes.string,
};

const mstp = (state) => ({
  formData: getFormValues(formName)(state),
  formSyncErrors: getFormSyncErrors(formName)(state),
  serviceLevelQuotes: state.user.serviceLevelQuotes,
  serviceLevelCode: state.user.serviceLevelCode,
  isAuthenticated: state.profile.isAuthenticated,
  accountNumbers: state.profile.accountNumbers,
  billingAccounts: state.profile.billingAccounts,
  division: state.profile.division,
  userId: state.profile.userId,
  userEmail: state.profile.email,
  userName: state.profile.fullName,
});

const mdtp = (dispatch) => ({
  putReduxServiceLevelQuotes: (serviceLevelQuotes) =>
    dispatch(putReduxServiceLevelQuotes(serviceLevelQuotes)),
  putReduxServiceLevelCode: (serviceLevelCode) =>
    dispatch(putReduxServiceLevelCode(serviceLevelCode)),
});

export default connect(
  mstp,
  mdtp,
)(CreateShipmentForm);
